/*
  speelgoes — verlanglijstje en verzamellijsten in het klantaccount, en "mail mijn lijstje naar mij".
  Praat met de app-proxy /apps/verzamel (server/lijst). Zonder login: alleen de inlogknop in [data-spg-account-blok].
  Bron van waarheid in de browser blijft localStorage (spg-lijstje-v1 en spg-verzamel-<serie>):
  bij de eerste login in deze browser worden browser en account samengevoegd, daarna wint het account,
  behalve als er nog een wijziging openstaat die niet bewaard is.
*/
(() => {
  if (window.SpgAccount) return;
  const cfgEl = document.querySelector('script[data-spg-account]');
  if (!cfgEl) return;
  let CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent) || {}; } catch (_) { return; }
  const T = CFG.tekst || {};
  const tk = (k, nl, v) => String(typeof T[k] === 'string' && T[k] ? T[k] : nl).replace(/\{(\w+)\}/g, (m, n) => (v && v[n] != null ? String(v[n]) : m));
  const PROXY = '/apps/verzamel';
  const LIJSTJE = 'spg-lijstje-v1';
  const VZ = 'spg-verzamel-';
  const SYNC = 'spg-account-sync';
  const VUIL = 'spg-account-vuil';
  const VERS = 'spg-account-vers';
  const VERS_MS = 10 * 60 * 1000;
  const MAX = 30;

  const ls = {
    lees(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (_) { return d; } },
    zet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (_) { return false; } },
    weg(k) { try { localStorage.removeItem(k); } catch (_) { /* niets */ } },
    sleutels() { try { return Object.keys(localStorage); } catch (_) { return []; } }
  };
  const meld = (naam, data) => { try { window.Shopify?.analytics?.publish?.('spg_account_' + naam, data || {}); } catch (_) { /* meten breekt nooit de pagina */ } };

  /* ---------- lokaal lijstje <-> accountvorm ---------- */
  const lokaal = () => {
    const l = ls.lees(LIJSTJE, {}) || {};
    const uit = { ids: Array.isArray(l.ids) ? l.ids.filter(Number.isSafeInteger).slice(0, MAX) : [] };
    if (Number.isSafeInteger(l.fav)) uit.fav = l.fav;
    if (typeof l.bij === 'string' && l.bij) uit.bij = l.bij;
    if (typeof l.voor === 'string' && l.voor) uit.voor = l.voor;
    const verzamel = {};
    ls.sleutels().filter((k) => k.startsWith(VZ)).forEach((k) => {
      const s = ls.lees(k, null);
      if (s && Array.isArray(s.heb) && Array.isArray(s.wil) && (s.heb.length || s.wil.length)) {
        verzamel[k.slice(VZ.length)] = s.pad ? { heb: s.heb, wil: s.wil, pad: s.pad } : { heb: s.heb, wil: s.wil };
      }
    });
    if (Object.keys(verzamel).length) uit.verzamel = verzamel;
    return uit;
  };
  const uniek = (a) => [...new Set(a)];
  const voegSamen = (a, b) => {
    const uit = { ids: uniek([...(a.ids || []), ...(b.ids || [])]).slice(0, MAX) };
    ['fav', 'bij', 'voor'].forEach((k) => { const v = a[k] != null ? a[k] : b[k]; if (v != null) uit[k] = v; });
    const series = uniek([...Object.keys(a.verzamel || {}), ...Object.keys(b.verzamel || {})]);
    if (series.length) {
      uit.verzamel = {};
      series.forEach((s) => {
        const x = (a.verzamel || {})[s] || { heb: [], wil: [] };
        const y = (b.verzamel || {})[s] || { heb: [], wil: [] };
        const heb = uniek([...x.heb, ...y.heb]);
        const wil = uniek([...x.wil, ...y.wil]).filter((n) => !heb.includes(n));
        const pad = x.pad || y.pad;
        uit.verzamel[s] = pad ? { heb, wil, pad } : { heb, wil };
      });
    }
    return uit;
  };
  let stil = false;
  const zetLokaal = (d) => {
    stil = true;
    const oud = ls.lees(LIJSTJE, {}) || {};
    const nieuw = { ...oud, ids: d.ids || [], fav: d.fav != null ? d.fav : null, bij: d.bij || oud.bij || '', voor: d.voor || oud.voor || '' };
    ls.zet(LIJSTJE, nieuw);
    Object.entries(d.verzamel || {}).forEach(([s, v]) => ls.zet(VZ + s, v));
    document.dispatchEvent(new CustomEvent('spg-lijstje', { detail: nieuw }));
    document.dispatchEvent(new CustomEvent('spg-lijstje-extern', { detail: nieuw }));
    document.dispatchEvent(new CustomEvent('spg-verzamel-extern'));
    stil = false;
  };
  const gelijk = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  /* ---------- praten met de app-proxy ---------- */
  const vraag = async (methode, actie, body) => {
    const q = new URLSearchParams();
    if (actie) q.set('actie', actie);
    if (actie === 'mail') q.set('taal', CFG.taal || 'nl');
    const r = await fetch(PROXY + (q.toString() ? '?' + q : ''), {
      method: methode, credentials: 'same-origin', keepalive: methode === 'POST' && actie === 'bewaar',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    let d = null;
    try { d = await r.json(); } catch (_) { /* geen json */ }
    return { status: r.status, d };
  };

  /* ---------- status in het blok ---------- */
  const vast = new Map();
  const blokken = () => {
    document.querySelectorAll('[data-spg-account-blok]').forEach((b) => { if (!vast.has(b)) vast.set(b, b.parentNode); });
    return [...vast.keys()];
  };
  // Op het verlanglijstje hoort het blok in "Deel je lijstje"; dat vak tekent het verlanglijstje telkens opnieuw.
  // Geen eigen lijstje in beeld (leeg of een gedeelde link): dan geen blok.
  const plaats = () => {
    blokken().forEach((b) => {
      if (b.dataset.spgAccountBlok !== 'verlanglijstje') { b.hidden = false; return; }
      const delen = document.querySelector('.spg-lijst-delen:not(.spg-lijst-delen--gast)');
      // Leeg eigen lijstje (alleen dat heeft de bladerlink): een gast kan inloggen om een bewaard lijstje op te halen.
      const leeg = !CFG.ingelogd && document.querySelector('.spg-lijst-leeg:has(.spg-lijst-leeg__blader)');
      const doel = delen || leeg;
      const modus = delen ? 'in' : leeg ? 'leeg' : '';
      if (doel) {
        if (b.parentNode !== doel) doel.append(b);
        b.classList.add('spg-acc--in');
        b.hidden = false;
        if (b.dataset.modus !== modus) { b.dataset.modus = modus; teken(b); }
      } else {
        b.hidden = true;
        if (!b.isConnected && vast.get(b) && vast.get(b).isConnected) vast.get(b).append(b);
      }
    });
  };
  let stand = CFG.ingelogd ? 'laden' : 'gast';
  const zetStand = (s, extra) => { stand = s; blokken().forEach((b) => teken(b, extra)); };

  let bewaarTimer = 0;
  let bewaarBezig = null;
  const bewaar = async () => {
    clearTimeout(bewaarTimer);
    bewaarTimer = 0;
    const lijst = lokaal();
    ls.zet(VUIL, true);
    zetStand('bewaren');
    try {
      const { status, d } = await vraag('POST', 'bewaar', lijst);
      if (status === 200 && d && d.ingelogd) { ls.weg(VUIL); ls.zet(VERS, { klant: String(CFG.klant), t: Date.now() }); zetStand('bewaard'); return true; }
    } catch (_) { /* hieronder */ }
    zetStand('fout');
    return false;
  };
  const bewaarStraks = () => {
    if (stil || !CFG.ingelogd) return;
    ls.zet(VUIL, true);
    if (stand === 'laden') return;
    clearTimeout(bewaarTimer);
    bewaarTimer = setTimeout(() => { bewaarTimer = 0; bewaarBezig = bewaar(); }, 800);
  };

  // Uitgelogd na een gesynct account: de lijst in deze browser hoort bij dat account (en staat daar bewaard).
  // Weghalen, zodat de volgende die hier inlogt hem niet in zijn eigen account samengevoegd krijgt.
  const ruimOp = () => {
    if (ls.lees(SYNC, null) == null || ls.lees(VUIL, false)) return;
    ls.weg(LIJSTJE);
    ls.sleutels().filter((k) => k.startsWith(VZ)).forEach((k) => ls.weg(k));
    ls.weg(SYNC);
    ls.weg(VERS);
    document.dispatchEvent(new CustomEvent('spg-lijstje-extern', { detail: { ids: [] } }));
    document.dispatchEvent(new CustomEvent('spg-verzamel-extern'));
  };

  const start = async () => {
    plaats();
    blokken().forEach((b) => teken(b));
    if (!CFG.ingelogd) { ruimOp(); return; }
    const klant = String(CFG.klant);
    const vorige = ls.lees(SYNC, null);
    const open = ls.lees(VUIL, false);
    // Pagina zonder accountblok, niets open en minder dan 10 minuten geleden gesynct: geen serververzoek.
    const vers = ls.lees(VERS, null);
    if (!blokken().length && !open && vorige === klant && vers && vers.klant === klant && Date.now() - vers.t < VERS_MS) { zetStand('bewaard'); return; }
    try {
      const { status, d } = await vraag('GET');
      if (status !== 200 || !d || !d.ingelogd) { zetStand('fout'); return; }
      const { v, ...account } = d.lijst || { ids: [] };
      const hier = lokaal();
      // Samenvoegen alleen bij de eerste login in deze browser (gastlijst). Stond hier een ander account, dan wint dit account.
      const eerste = vorige == null;
      const ander = vorige != null && vorige !== klant;
      const uitkomst = eerste ? voegSamen(hier, account) : ander ? account : open ? hier : account;
      if (!gelijk(uitkomst, hier)) zetLokaal(uitkomst);
      ls.zet(SYNC, klant);
      if (ander) ls.weg(VUIL);
      if (eerste) meld('samengevoegd', { lokaal: hier.ids.length, account: (account.ids || []).length });
      if (eerste || (open && !ander)) await bewaar(); else { ls.zet(VERS, { klant, t: Date.now() }); zetStand('bewaard'); }
    } catch (_) { zetStand('fout'); }
  };

  /* ---------- mailen ---------- */
  let mailStand = '';
  const mail = async () => {
    mailStand = 'bezig'; zetStand(stand);
    if (bewaarTimer || ls.lees(VUIL, false)) await bewaar();
    else if (bewaarBezig) await bewaarBezig;
    try {
      const { status, d } = await vraag('POST', 'mail');
      if (status === 200) { mailStand = 'klaar'; meld('mail', { aantal: lokaal().ids.length }); }
      else if (status === 429) mailStand = 'wacht:' + Math.max(1, Math.ceil(((d && d.opnieuw_over_s) || 60) / 60));
      else if (status === 400) mailStand = 'leeg';
      else mailStand = 'fout';
    } catch (_) { mailStand = 'fout'; }
    zetStand(stand);
  };

  /* ---------- het blok tekenen ---------- */
  const el = (tag, attrs, ...kids) => {
    const e = document.createElement(tag);
    Object.entries(attrs || {}).forEach(([k, v]) => { if (v == null || v === false) return; if (k === 'tekst') e.textContent = v; else if (k.startsWith('on')) e.addEventListener(k.slice(2), v); else e.setAttribute(k, v === true ? '' : v); });
    kids.flat().forEach((k) => k != null && e.append(k));
    return e;
  };
  const loginUrl = () => {
    const terug = location.pathname + location.search + location.hash;
    const u = (CFG.login || '/customer_authentication/login').replace(/([?&])return_to=[^&]*&?/, '$1').replace(/[?&]$/, '');
    return u + (u.includes('?') ? '&' : '?') + 'return_to=' + encodeURIComponent(terug);
  };

  /* ---------- inloggen in het venster van Shopify (shopify-account in de header), daarna terug naar deze pagina ---------- */
  const TERUG = 'spg-na-inloggen';
  const terugNa = () => {
    let t = null;
    try { t = JSON.parse(sessionStorage.getItem(TERUG) || 'null'); sessionStorage.removeItem(TERUG); } catch (_) { return; }
    if (!t || typeof t.pad !== 'string' || !t.pad.startsWith('/') || t.pad.startsWith('//') || Date.now() - t.tijd > 30 * 60 * 1000) return;
    if (t.pad !== location.pathname + location.search + location.hash) location.replace(t.pad);
  };
  if (CFG.ingelogd) terugNa();
  document.addEventListener('click', (e) => {
    const a = !CFG.ingelogd && e.target.closest && e.target.closest('a[data-spg-login]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const venster = [...document.querySelectorAll('shopify-account')].find((x) => typeof x.showModal === 'function');
    try { sessionStorage.setItem(TERUG, JSON.stringify({ pad: location.pathname + location.search + location.hash, tijd: Date.now() })); } catch (_) { /* dan alleen return_to */ }
    meld('login_klik', { plaats: a.dataset.spgLogin || '', venster: Boolean(venster) });
    if (!venster) return;
    e.preventDefault();
    const oud = venster.getAttribute('sign-in-url');
    venster.setAttribute('sign-in-url', loginUrl());
    venster.addEventListener('close', () => { if (oud == null) venster.removeAttribute('sign-in-url'); else venster.setAttribute('sign-in-url', oud); }, { once: true });
    venster.showModal();
  });
  const teken = (b) => {
    b.classList.toggle('is-ingelogd', Boolean(CFG.ingelogd));
    if (!CFG.ingelogd && b.dataset.modus === 'leeg') {
      b.replaceChildren(
        el('p', { class: 'spg-acc__kop', tekst: tk('leeg_kop', 'Al een lijstje bewaard?') }),
        el('p', { class: 'spg-acc__sub', tekst: tk('leeg_sub', 'Log in, dan halen we het op uit je account.') }),
        el('a', { class: 'spg-acc__knop', href: loginUrl(), 'data-spg-login': 'leeg', tekst: tk('leeg_knop', 'Inloggen') })
      );
      return;
    }
    if (!CFG.ingelogd) {
      b.replaceChildren(
        el('p', { class: 'spg-acc__kop', tekst: tk('gast_kop', 'Bewaar je lijstje in je account') }),
        el('p', { class: 'spg-acc__sub', tekst: tk('gast_sub', 'Log in met je e-mailadres. Dan raak je je lijstje nooit kwijt, zie je het op elk apparaat en mail je het naar jezelf.') }),
        el('a', { class: 'spg-acc__knop', href: loginUrl(), 'data-spg-login': b.dataset.spgAccountBlok || 'blok', tekst: tk('gast_knop', 'Inloggen of account maken') })
      );
      return;
    }
    const standTekst = {
      laden: tk('laden', 'Je account ophalen…'),
      bewaren: tk('bewaren', 'Bewaren in je account…'),
      bewaard: tk('bewaard', 'Bewaard in je account'),
      fout: tk('fout', 'Bewaren in je account lukte niet. Je lijstje staat nog wel in deze browser.')
    }[stand] || '';
    let mailTekst = '';
    if (mailStand === 'klaar') mailTekst = tk('mail_klaar', 'Verstuurd naar {email}. Kijk in je inbox.', { email: CFG.email || '' });
    else if (mailStand === 'leeg') mailTekst = tk('mail_leeg', 'Je lijstje is nog leeg. Tik eerst op een hartje.');
    else if (mailStand === 'fout') mailTekst = tk('mail_fout', 'Versturen lukte niet. Probeer het zo nog een keer.');
    else if (mailStand.startsWith('wacht:')) mailTekst = tk('mail_wacht', 'Net verstuurd. Over {minuten} min kun je hem opnieuw mailen.', { minuten: mailStand.slice(6) });
    const knop = el('button', { type: 'button', class: 'spg-acc__knop', disabled: mailStand === 'bezig' || stand === 'laden', onclick: mail },
      el('span', { tekst: mailStand === 'bezig' ? tk('mail_bezig', 'Even geduld') : tk('mail_knop', 'Mail mijn lijstje naar mij') }));
    b.replaceChildren(...[
      el('p', { class: 'spg-acc__stand' + (stand === 'fout' ? ' is-fout' : ''), role: 'status', tekst: standTekst }),
      knop,
      el('p', { class: 'spg-acc__sub', tekst: CFG.email ? tk('mail_naar', 'We sturen hem naar {email}.', { email: CFG.email }) : '' }),
      mailTekst ? el('p', { class: 'spg-acc__melding', role: 'status', tekst: mailTekst }) : null
    ].filter(Boolean));
  };

  document.documentElement.classList.toggle('spg-ingelogd', Boolean(CFG.ingelogd));
  document.addEventListener('spg-lijstje', bewaarStraks);
  document.addEventListener('spg-verzamel', bewaarStraks);
  window.addEventListener('pagehide', () => { if (bewaarTimer) { clearTimeout(bewaarTimer); bewaar(); } });
  let wacht = 0;
  new MutationObserver(() => {
    if (wacht) return;
    wacht = requestAnimationFrame(() => {
      wacht = 0;
      plaats();
      blokken().forEach((b) => { if (!b.childElementCount) teken(b); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.SpgAccount = { _voegSamen: voegSamen, _lokaal: lokaal };
})();
